import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  permissionRecords: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  targetScore: [],
  structureType: [],
  filterStructure: [],
  filterStructureType: [],
  filterActive: [],
  message: {},
  stage: [],
  loadingStates: []
}

const fetchStructureStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchStructureSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name,
      value_list_name: data?.structure_type?.value_list_name
    }
  })
  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    records: records
  }
}

const fetchStructureFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    message: action.errorMessage
  }
}

const fetchStructureByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedStructureRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true, roles: [] },
    success: false
  }
}

const createStructureStart = (state, action) => {
  return { ...state, loading: true }
}

const createStructureSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createStructureFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateStructureStart = (state, action) => {
  return { ...state, loading: true }
}

const updateStructureSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateStructureFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteStructureStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteStructureSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteStructureFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchStageStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchStageSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    stage: action.data
  }
}

const fetchStageFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchTargetScoreStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchTargetScoreSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    targetScore: action.data
  }
}

const fetchTargetScoreFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchStructureTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchStructureTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    structureType: action.data
  }
}

const fetchStructureTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    permissionRecords: action.data
  }
}

const fetchRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchStructureFilterStructureStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchStructureFilterStructureSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterStructure: action.data
  }
}

const fetchStructureFilterStructureFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchStructureFilterStructureTypeStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchStructureFilterStructureTypeSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterStructureType: action.data
  }
}

const fetchStructureFilterStructureTypeFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchStructureFilterActiveStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchStructureFilterActiveSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterActive: action.data
  }
}

const fetchStructureFilterActiveFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_STRUCTURE_START:
      return fetchStructureStart(state, action)
    case actionTypes.FETCH_STRUCTURE_SUCCESS:
      return fetchStructureSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_BY_ID_SUCCESS:
      return fetchStructureByIdSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_FAILED:
      return fetchStructureFailed(state, action)
    case actionTypes.CLEAR_SELECTED_STRUCTURE_RECORD:
      return clearSelectedStructureRecord(state, action)
    case actionTypes.CREATE_STRUCTURE_START:
      return createStructureStart(state, action)
    case actionTypes.CREATE_STRUCTURE_SUCCESS:
      return createStructureSuccess(state, action)
    case actionTypes.CREATE_STRUCTURE_FAILED:
      return createStructureFailed(state, action)
    case actionTypes.UPDATE_STRUCTURE_START:
      return updateStructureStart(state, action)
    case actionTypes.UPDATE_STRUCTURE_SUCCESS:
      return updateStructureSuccess(state, action)
    case actionTypes.UPDATE_STRUCTURE_FAILED:
      return updateStructureFailed(state, action)
    case actionTypes.DELETE_STRUCTURE_START:
      return deleteStructureStart(state, action)
    case actionTypes.DELETE_STRUCTURE_SUCCESS:
      return deleteStructureSuccess(state, action)
    case actionTypes.DELETE_STRUCTURE_FAILED:
      return deleteStructureFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_TARGET_SCORE_OPTIONS_START:
      return fetchTargetScoreStart(state, action)
    case actionTypes.FETCH_TARGET_SCORE_OPTIONS_SUCCESS:
      return fetchTargetScoreSuccess(state, action)
    case actionTypes.FETCH_TARGET_SCORE_OPTIONS_FAILED:
      return fetchTargetScoreFailed(state, action)
    case actionTypes.FETCH_STRUCTURE_TYPE_OPTIONS_START:
      return fetchStructureTypeStart(state, action)
    case actionTypes.FETCH_STRUCTURE_TYPE_OPTIONS_SUCCESS:
      return fetchStructureTypeSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_TYPE_OPTIONS_FAILED:
      return fetchStructureTypeFailed(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_START:
      return fetchRoleStart(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_SUCCESS:
      return fetchRoleSuccess(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_FAILED:
      return fetchRoleFailed(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_START:
      return fetchStructureFilterStructureStart(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_SUCCESS:
      return fetchStructureFilterStructureSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_FAILED:
      return fetchStructureFilterStructureFailed(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_START:
      return fetchStructureFilterStructureTypeStart(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_SUCCESS:
      return fetchStructureFilterStructureTypeSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_FAILED:
      return fetchStructureFilterStructureTypeFailed(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_ACTIVE_START:
      return fetchStructureFilterActiveStart(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_ACTIVE_SUCCESS:
      return fetchStructureFilterActiveSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_FILTER_ACTIVE_FAILED:
      return fetchStructureFilterActiveFailed(state, action)
    case actionTypes.FETCH_STAGE_OPTIONS_START:
      return fetchStageStart(state, action)
    case actionTypes.FETCH_STAGE_OPTIONS_SUCCESS:
      return fetchStageSuccess(state, action)
    case actionTypes.FETCH_STAGE_OPTIONS_FAILED:
      return fetchStageFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
